<template>
    <Modal
        :title="$t('labels.create_supplier')"
        ref="modal"
    >
        <div class="modal-body">
            <FormGroup :label="$t('labels.name')">
                <Input v-model="supplierName" />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="indigo" @click="createSupplier">
                <span>{{ $t('buttons.create') }}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import Button from '../../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../../services/HttpClient';
export default {
    name: "CreateSupplierModal",
    components: {
        Modal, FormGroup, Input, Button
    },
    emits: ['created'],
    data() {
        return {
            supplierName: ''
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        async createSupplier() {
            await httpClient.post('/management/suppliers', {name: this.supplierName}).then(() => {
                this.$refs.modal.hide();
                this.supplierName = '';
                this.$emit('created');
            });
        }
    }
}
</script>
